module.exports = __webpack_public_path__ + "img/why-icon-active-3.29398fa4.svg";